// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__B0L1j","boxTitle":"Qualiphy_boxTitle__1O-vK","box":"Qualiphy_box__1y_2t","toggleWrap":"Qualiphy_toggleWrap__kPi5p"};